﻿import React, { useState, useEffect } from 'react';

import { TextBox, TextArea } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { CrudFunctions } from '../utilities/crud-functions';


export default function NotificationTester() {
    const [subject, setSubject] = useState<string>(null);
    const [body, setBody] = useState<string>(null);
    const [recipients, setRecipients] = useState<string>(null);

    return (
        <div>
            <div id="pb-title-pane">
                <div className="lq-title-bar">
                    <div className="lq-main-title">Notification Tester</div>
                </div>
            </div>

            <div className="form-container">
                <div id="mainPanel" className="pw-form-section">
                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Subject</div>
                        <TextBox className="textbox"
                            onValueChanged={onSubjectValueChanged}
                            placeholder='Subject'
                            value={subject ? subject : undefined} />
                    </div>

                    <div className="pw-form-unit">
                        <div className="pw-form-unit-label">Recipients</div>
                        <TextBox className="textbox"
                            onValueChanged={onRecipientsValueChanged}
                            placeholder='Recipients'
                            value={recipients ? recipients : undefined} />
                    </div>

                    <div className="pw-form-unit">
                        <TextArea height={100} placeholder='Body'
                            value={body ? body : undefined}
                            onValueChanged={onBodyValueChanged} />
                    </div>

                    <div className="pw-comp-row">
                        <div>
                            <Button className="title-bar-button"
                                text="Send" type="normal"
                                hint="send email"
                                onClick={sendEmail} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function onSubjectValueChanged(e: any) {
        setSubject(e.value);
    }

    function onRecipientsValueChanged(e: any) {
        setRecipients(e.value);
    }

    function onBodyValueChanged(e: any) {
        setBody(e.value);
    }

    async function sendEmail() {
        const email = {
            "message": {
                "subject": "Meet for breakfast?",
                "body": {
                    "contentType": "Text",
                    "content": "Silver Grill is open."
                },
                "toRecipients": [
                    {
                        "emailAddress": {
                            "address": "mattiya7@gmail.com"
                        }
                    }
                ]
            }
        }

        let response = await CrudFunctions.postData("https://graph.microsoft.com/v1.0/me/sendMail", email)
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.error(err);

            });
    }

}

